module.exports = "<app-header></app-header>\r\n<ng4-loading-spinner class=\"custom_spinner\"> </ng4-loading-spinner>\r\n<app-footer></app-footer>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main